import { Alert, Button, Form, Input, Popconfirm, Table, message } from 'antd';
import dayjs from 'dayjs';
import { Component, createRef } from 'react';
import DuplicateCompanyDialog from './DuplicateCompanyDialog.jsx';

class CompanyCard extends Component {
	constructor(props) {
		super(props);
		this.state = {
			emailExists: false,
			companyExists: false,
			serverError: false,
			duplicateSource: null,
			companySearch: '',
		};
		// Create form ref for v4
		this.formRef = createRef();
	}

	handleSubmit = async (values) => {
		const { addUser, addCompany, addDepartment, currentUser, addUserGroup } =
			this.props;

		this.setState({
			companyExists: false,
			emailExists: false,
			serverError: false,
		});

		try {
			const companyData = await addCompany({
				input: {
					name: values.company,
				},
			});

			const addDepartmentPromise = addDepartment({
				input: {
					companyId: companyData.data.createCompany.id,
					name: 'Other',
					active: true,
				},
			});

			const addUserGroupPromise = addUserGroup({
				input: {
					companyId: companyData.data.createCompany.id,
					name: 'Default',
					active: true,
					currency: 'USD',
				},
			});

			const addExternalUserGroupPromise = addUserGroup({
				input: {
					companyId: companyData.data.createCompany.id,
					name: 'External',
					active: true,
				},
			});

			await Promise.all([
				addDepartmentPromise,
				addUserGroupPromise,
				addExternalUserGroupPromise,
			]);

			message.config({
				top: 40,
			});

			message.success('Company Successfully Created!', 2.5, () => {
				this.formRef.current.resetFields();
			});
		} catch (error) {
			this.setState({ serverError: true });
			console.error(error);
		}
	};

	handleSubmitFailed = (errorInfo) => {
		console.log('Failed:', errorInfo);
	};

	// Handler for the Popconfirm - validates form first
	handlePopconfirmConfirm = () => {
		this.formRef.current.submit();
	};

	render() {
		const search = this.state.companySearch.trim().toLowerCase();
		const dataSource = this.props.companies
			.map((company, index) => ({
				key: company.id || index, // Add key for table rows
				id: company.id,
				name: company ? company.name : '',
				date: company.dateCreated,
			}))
			.filter((company) => company.name.toLowerCase().includes(search));

		const columns = [
			{
				title: 'Company Name',
				dataIndex: 'name',
				key: 'name',
			},
			{
				title: 'Date Added',
				dataIndex: 'date',
				key: 'date',
				render: (dateAdded) => dayjs(dateAdded).format('M/D/YYYY'),
			},
			{
				title: 'Actions',
				key: 'actions',
				render: (_, record) =>
					record.id ? (
						<Button
							type="link"
							onClick={() => this.setState({ duplicateSource: record })}
						>
							Duplicate
						</Button>
					) : null,
			},
		];

		const { emailExists, companyExists, serverError, duplicateSource } =
			this.state;

		return (
			<div className="custom-card">
				<h5>Add a New Company</h5>
				<Form
					ref={this.formRef}
					onFinish={this.handleSubmit}
					onFinishFailed={this.handleSubmitFailed}
				>
					<div className="add-company-form">
						<Form.Item
							name="company"
							rules={[
								{
									required: true,
									message: 'Company name required',
								},
							]}
						>
							<div
								className="custom-form-group"
								style={{ marginRight: 10, width: 300 }}
							>
								<label className="custom-label">Company Name</label>
								<Input className="custom-input" />
							</div>
						</Form.Item>

						<Form.Item>
							<Popconfirm
								key={1}
								title="Are you sure you want to create this new company?"
								placement="bottom"
								okText="Yes"
								cancelText="No"
								onConfirm={this.handlePopconfirmConfirm}
							>
								<Button type="primary" size="large">
									Create Company
								</Button>
							</Popconfirm>
						</Form.Item>
					</div>

					{companyExists && (
						<Alert type="error" message="Company already exists" />
					)}
					{emailExists && (
						<Alert type="error" message="Email is already in use" />
					)}
					{serverError && <Alert type="error" message="Server error" />}
				</Form>

				<div className="table-card">
					<Input.Search
						allowClear
						placeholder="Search companies by name"
						style={{ width: 300, marginBottom: 12 }}
						value={this.state.companySearch}
						onChange={(e) => this.setState({ companySearch: e.target.value })}
					/>
					<Table
						dataSource={dataSource}
						columns={columns}
						pagination={{
							pageSize: 10,
							showSizeChanger: true,
							showQuickJumper: true,
						}}
					/>
				</div>

				<DuplicateCompanyDialog
					sourceCompany={duplicateSource}
					companies={this.props.companies}
					addCompany={this.props.addCompany}
					onClose={() => this.setState({ duplicateSource: null })}
				/>
			</div>
		);
	}
}

export default CompanyCard;
